module.exports = __webpack_public_path__ + "img/Unidad15-6.c0b2e1ac.png";